<template>
  <div>
    

    <div class="container">
      <div class="column" v-if="column1">
        <h4><q-icon name="cloud_upload" /> Importer des fichiers pour la création de la page d'accueil</h4>
        <div
          class="drop-zone"
          :class="{ 'drop-zone--active': isDragging }"
          @dragover.prevent="isDragging = true"
          @dragenter.prevent="isDragging = true"
          @dragleave.prevent="isDragging = false"
          @drop.prevent="onDrop"
        >
          <q-icon name="cloud_upload" size="48px" :color="isDragging ? 'primary' : 'grey-6'" />
          <p class="q-mt-sm q-mb-xs" style="font-size: 14px;">
            Glissez-déposez vos fichiers ici
          </p>
          <p class="text-caption text-grey-6 q-mb-sm">
            (Images, Vidéos, Audios, Documents Word)
          </p>
          <q-file
            v-model="selectedFiles"
            label="ou cliquez pour sélectionner"
            outlined
            dense
            multiple
            accept="image/*,video/*,audio/*,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            @update:model-value="onFilesSelected"
            style="max-width: 300px;"
          >
            <template v-slot:prepend>
              <q-icon name="attach_file" />
            </template>
          </q-file>
        </div>

        <!-- Liste des fichiers sélectionnés -->
        <div v-if="filesToUpload.length > 0" class="q-mt-md">
          <div class="text-subtitle2 q-mb-sm">{{ filesToUpload.length }} fichier(s) sélectionné(s)</div>
          <q-list bordered separator class="rounded-borders q-mb-md">
            <q-item v-for="(f, idx) in filesToUpload" :key="idx" class="q-pa-sm">
              <q-item-section>
                <div class="row items-center q-mb-xs">
                  <q-icon :name="getFileIcon(f.file.name)" class="q-mr-sm" />
                  <span class="text-weight-medium">{{ f.file.name }}</span>
                  <q-space />
                  <q-icon name="close" class="cursor-pointer" color="negative"
                    @click="filesToUpload.splice(idx, 1)" />
                </div>
                <div class="row q-col-gutter-sm">
                  <div class="col-6">
                    <q-input v-model="f.title" label="Titre" dense outlined />
                  </div>
                  <div class="col-6">
                    <q-input v-model="f.source" label="Nom de la source" dense outlined />
                  </div>
                  <div class="col-6">
                    <q-input v-model="f.description" label="Description" dense outlined
                      type="textarea" autogrow />
                  </div>
                  <div class="col-6">
                    <q-input v-model="f.source_url" label="URL de la source" dense outlined />
                  </div>
                </div>
              </q-item-section>
            </q-item>
          </q-list>
          <q-btn @click="importFiles" color="secondary" label="Importer tous les fichiers" :loading="uploading" />
        </div>

        <!-- Progression -->
        <div v-if="uploading" class="q-mt-md">
          <div class="text-caption q-mb-xs">
            Fichier {{ uploadCurrent }} / {{ uploadTotal }}
          </div>
          <q-linear-progress :value="uploadProgress / 100" color="blue" />
          <div class="text-caption text-center q-mt-xs">{{ uploadProgress }}%</div>
        </div>

        <div class="loader" style="z-index: 11000;" v-if="loading && !uploading">
          <q-spinner-gears size="50px" color="black" />
        </div>
        <div v-if="success" class="banner banner-success">
          Enregistrement réussi
        </div>
        <div v-if="saveError" class="banner banner-error">
          Échec de l'enregistrement
        </div>
        <div class="q-mt-md">
          <q-btn label="Gérer les fichiers" color="warning" @click="resourcesList = true" />
          <q-dialog v-model="resourcesList" maximized @hide="getResources">
            <MediaManager :exhibitId="exhibitId" />
          </q-dialog>
        </div>
      </div>
      <div class="column" v-if="column2">
        <h4><q-icon name="preview" /> Prévisualiser la page d'accueil</h4>
        <div class="iframe-wrapper">
          <p v-if="resourceSelected === null">Veuillez enregistrer une image d'accueil pour la prévisualiser</p>

          <iframe :key="iframeKey" v-else class="preview-iframe" :src="embedUrl"></iframe>
        </div>

      </div>
      <div class="column" v-if="column3">
        <div>
          <h4><q-icon name="home" /> Paramétrer la page d'accueil</h4>
          <FileSelect v-model="resourceSelected" :options="resources" option-label="title" label="Image d'accueil"
            emit-value map-options />
          <br>
          <q-input v-model="homePageText" filled type="textarea" label="Texte d'accueil" />
          <br>
          <q-input v-model="homePageText2" filled type="textarea" label="Texte du bouton de lancement de l'exposition" />
          <br>
          <FileSelect clearable v-model="launchResourceSelected" :options="resources" option-label="title" option-value="id"
            label="Image du bouton de lancement de l'exposition" emit-value map-options />
          <br>
          <q-btn @click="sendHomePageImage" color="secondary" label="Enregistrer" />
        </div>
        <div>
          <h4><q-icon name="layers" /> Sélectionner un modèle de page d'acceuil</h4>
          <q-select v-model="selectedTemplate" :options="templates" label="Modèles">
          </q-select>
          <br>
          <q-btn color="secondary" label="Enregistrer" @click="saveModel"></q-btn>
        </div>
        <div>
          <h4><q-icon name="open_with" /> Position du texte et du bouton d'entrée</h4>
          <q-btn color="secondary" label="Positionner sur l'accueil" @click="layoutEditor = true" />
          <q-dialog v-model="layoutEditor" maximized @hide="iframeKey++">
            <HomeLayoutEditor :exhibitId="exhibitId" @saved="iframeKey++" />
          </q-dialog>
        </div>
        <div>
          <h4><q-icon name="arrow_back" /> Bouton « retour » (vue ressource)</h4>
          <q-btn-toggle v-model="returnSource" toggle-color="secondary" :options="[
            { label: 'Icône', value: 'icon' },
            { label: 'Image', value: 'image' }
          ]" />
          <div v-if="returnSource === 'icon'" class="q-my-sm" style="display:flex; flex-wrap:wrap; max-width:340px;">
            <q-icon v-for="ic in iconCatalog" :key="ic" :name="ic" size="26px"
              class="cursor-pointer q-pa-xs"
              :color="returnIcon === ic ? 'secondary' : 'grey-7'"
              @click="returnIcon = ic; returnImageId = null" />
          </div>
          <FileSelect v-else clearable :options="resources" option-label="title" option-value="id"
            emit-value map-options outlined dense class="q-my-sm" v-model="returnImageId" label="Image du bouton"
            @update:model-value="returnIcon = null" />
          <q-btn color="secondary" label="Enregistrer" @click="saveReturnButton" />
        </div>
        <div>
          <h4><q-icon name="palette" /> Sélectionner une couleur de fond</h4>
          <q-input filled v-model="color" class="my-input" label="Couleur" dense>
            <template v-slot:append>
              <q-icon name="colorize" class="cursor-pointer">
                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                  <q-color v-model="color" />
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
          <br>
          <q-btn color="secondary" label="Enregistrer" @click="saveColor"></q-btn>

        </div>

        <CharteGraphique :exhibitId="exhibitId" />

        <Rights @rightsAdded="rightsAdded" ref="rightsRef" />
      </div>
    </div>

  </div>
</template>
  
<script>
import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
//import { useRouter } from 'vue-router';
import axios from 'axios';
import MediaManager from './MediaManager.vue';
import CharteGraphique from './CharteGraphique.vue';
import Rights from './Rights.vue';
import FileSelect from './FileSelect.vue';
import { ICON_CATALOG } from '../utils/iconCatalog';
import HomeLayoutEditor from './HomeLayoutEditor.vue';
import { useRouter } from 'vue-router';
import { lastRoute } from '../router/index';

export default {
  components: {
    MediaManager,
    CharteGraphique,
    Rights,
    FileSelect,
    HomeLayoutEditor
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const welcomeText = ref('');
    const embedUrl = computed(() => store.getters.exhibitUrl);
    const selectedTemplate = ref("Modèle 1");
    let resources = ref([]);
    let homePageText = ref("");
    let resourceSelected = ref(null);
    let firstImage = ref(false);
    let iframeKey = ref(0);
    let loading = ref(false);
    let success = ref(false);
    let resourcesList = ref(false);
    let layoutEditor = ref(false);
    let returnSource = ref('icon');
    let returnIcon = ref(null);
    let returnImageId = ref(null);
    const iconCatalog = ICON_CATALOG;
    let exhibitId = computed(() => store.state.exhibitId);
    let homePageText2 = ref("");
    let rightsRef = ref(null);
    let saveError = ref(false)
    let color = ref("#ffffff");
    let uploading = ref(false);
    let uploadProgress = ref(0);
    let isDragging = ref(false);
    let selectedFiles = ref(null);
    let filesToUpload = ref([]);
    let uploadCurrent = ref(0);
    let uploadTotal = ref(0);
    let exhibitTemplate = ref();
    let launchResourceSelected = ref();
    let column1 = ref(true);
    let column2 = ref(true);
    let column3 = ref(true);
    const templates = ref([
      "Modèle 1", "Modèle 2", "Modèle 3", "Modèle 4", "Modèle 5", "Modèle 6", "Modèle 7"
      // Autres modèles...
    ]);



    //Récupération de ressources
    const getResources = async () => {
      try {
        let url = `${process.env.VUE_APP_BASEURL}/resources`;
        let body = {
          exhibitId: store.state.exhibitId,
        };
        let response = await axios.post(url, body);
        resources.value = response.data;
        resources.value = resources.value.sort((a, b) => {
          const titleA = a.title ? a.title.toUpperCase() : "";
          const titleB = b.title ? b.title.toUpperCase() : "";
          if (titleA < titleB) return -1;
          if (titleA > titleB) return 1;
          return 0;
        });
      } catch (error) {
        console.log(error);
      }
    }

    //Récupération de l'image d'accueil
    const getHomePageImage = async () => {
      try {
        let url = `${process.env.VUE_APP_BASEURL}/exhibit_home/${store.state.exhibitId}`;
        let response = await axios.get(url);
        if (response.data.length > 0) {
          resourceSelected.value = response.data[0];
          homePageText.value = response.data[0].text;
          homePageText2.value = response.data[0].launch_text;
          launchResourceSelected.value = response.data[0].launch_image_id;
          returnIcon.value = response.data[0].return_icon || null;
          returnImageId.value = response.data[0].return_image_id || null;
          returnSource.value = returnImageId.value ? 'image' : 'icon';
          firstImage.value = false;
        } else {
          firstImage.value = true;
        }
      } catch (error) {
        console.log(error);
      }
    }

    const sendHomePageImage = async () => {
      try {
        let url = `${process.env.VUE_APP_BASEURL}/exhibit_home`;
        if (firstImage.value) {
          let body = {
            exhibitId: store.state.exhibitId,
            resourceId: resourceSelected.value.id,
            text: homePageText.value,
            launch_text: homePageText2.value,
            launch_image_id: launchResourceSelected.value
          };
          await axios.post(url, body);
        } else {
          let body = {
            exhibitId: store.state.exhibitId,
            resourceId: resourceSelected.value.id,
            text: homePageText.value,
            launch_text: homePageText2.value,
            launch_image_id: launchResourceSelected.value

          };
          await axios.put(url, body);
        }
        iframeKey.value++;
        await saveColor();
        await saveModel();
        await getHomePageImage();
      } catch (error) {
        console.log(error);
        saveError.value = true;
        setTimeout(() => {
          saveError.value = false;
        }, 1500);
        throw error;

      }
    }

    const saveRights = () => {
      if (rightsRef.value) {
        rightsRef.value.addRights();
      }
    }

    const rightsAdded = () => {
      console.log("rights added")
      iframeKey.value++;
    }

    const getFileIcon = (name) => {
      if (!name) return 'insert_drive_file';
      const ext = name.split('.').pop().toLowerCase();
      if (['jpg','jpeg','png','gif','svg','webp','bmp','tiff'].includes(ext)) return 'image';
      if (['mp4','avi','mov','wmv','webm','mkv'].includes(ext)) return 'videocam';
      if (['mp3','wav','ogg','flac','aac'].includes(ext)) return 'audiotrack';
      if (['doc','docx'].includes(ext)) return 'description';
      return 'insert_drive_file';
    };

    const addFiles = (files) => {
      const MAX_SIZE = 10000000;
      for (const file of files) {
        if (file.size > MAX_SIZE) {
          alert(`"${file.name}" est volumineux, le chargement peut être long.`);
        }
        filesToUpload.value.push({
          file,
          title: file.name.replace(/\.[^/.]+$/, ''),
          description: '',
          source: '',
          source_url: '',
        });
      }
    };

    const onDrop = (event) => {
      isDragging.value = false;
      const files = event.dataTransfer.files;
      if (files.length > 0) addFiles(files);
    };

    const onFilesSelected = (files) => {
      if (files && files.length > 0) {
        addFiles(files);
        selectedFiles.value = null;
      }
    };

    const importFiles = async () => {
      if (filesToUpload.value.length === 0) return;
      try {
        uploading.value = true;
        loading.value = true;
        uploadTotal.value = filesToUpload.value.length;

        for (let i = 0; i < filesToUpload.value.length; i++) {
          uploadCurrent.value = i + 1;
          uploadProgress.value = 0;

          const item = filesToUpload.value[i];
          let formData = new FormData();
          formData.append("file", item.file);
          formData.append("name", item.file.name);
          formData.append("title", item.title);
          formData.append("description", item.description);
          if (item.source) formData.append("source", item.source);
          if (item.source_url) formData.append("source_url", item.source_url);
          if (store.state.exhibitId) formData.append("exhibitId", store.state.exhibitId);
          if (store.state.resourcesCount !== undefined) formData.append("index", store.state.resourcesCount);

          let url = `${process.env.VUE_APP_BASEURL}/file`;
          await axios.post(url, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            onUploadProgress: (progressEvent) => {
              if (progressEvent.lengthComputable) {
                uploadProgress.value = Math.round((progressEvent.loaded * 100) / progressEvent.total);
              }
            }
          });
        }

        uploading.value = false;
        loading.value = false;
        filesToUpload.value = [];
        success.value = true;
        setTimeout(() => {
          success.value = false;
        }, 1500);
        await getResources();
      } catch (error) {
        console.log(error);
        saveError.value = true;
        uploading.value = false;
        setTimeout(() => {
          saveError.value = false;
          loading.value = false;
        }, 1500);
      }
    };

    const saveColor = async () => {
      try {
        let url = `${process.env.VUE_APP_BASEURL}/homeBackgroundColor`;
        let postBody = {
          "exhibitId": exhibitId.value,
          "color": color.value
        }
        await axios.put(url, postBody);
        success.value = true;
        setTimeout(() => {
          success.value = false;
          iframeKey.value++;
        }, 1500)
      } catch (error) {
        console.log(error);
        saveError.value = true;
        setTimeout(() => {
          saveError.value = false;
        }, 1500)
      }
    }

    const fetchColor = async () => {
      try {
        let url = `${process.env.VUE_APP_BASEURL}/homeBackgroundColor/${store.state.exhibitId}`;
        let response = await axios.get(url);
        if (response.data.length > 0) {
          color.value = response.data[0].color;
        }
        if (color.value == null) {
          color.value = "#ffffff"
        }
      } catch (error) {
        console.log(error);
      }
    }

    const saveReturnButton = async () => {
      try {
        let url = `${process.env.VUE_APP_BASEURL}/exhibit_home/return-button`;
        await axios.put(url, {
          exhibitId: exhibitId.value,
          return_icon: returnSource.value === 'icon' ? returnIcon.value : null,
          return_image_id: returnSource.value === 'image' ? returnImageId.value : null,
        });
        success.value = true;
        setTimeout(() => { success.value = false; iframeKey.value++; }, 1500);
      } catch (error) {
        console.log(error);
        saveError.value = true;
        setTimeout(() => { saveError.value = false; }, 1500);
      }
    };

    const saveModel = async () => {
      try {
        let url = `${process.env.VUE_APP_BASEURL}/model`;
        let postBody = {
          "exhibitId": exhibitId.value,
          "template": selectedTemplate.value
        }
        await axios.put(url, postBody);
        success.value = true;
        setTimeout(() => {
          success.value = false;
          iframeKey.value++;
        }, 1500)
      } catch (error) {
        console.log(error);
        saveError.value = true;
        setTimeout(() => {
          saveError.value = false;
        }, 1500)
      }
    }

    const fetchModel = async () => {
      try {
        let url = `${process.env.VUE_APP_BASEURL}/model/${store.state.exhibitId}`;
        let response = await axios.get(url);
        if (response.data.length > 0) {
          selectedTemplate.value = response.data[0].model || "Modèle 1";
        }
      } catch (error) {
        console.log(error);
      }
    }

    const hasTemplate = async () => {
      try {
        let result = false;
        let url = `${process.env.VUE_APP_BASEURL}/template/${store.state.exhibitId}`;
        let response = await axios.get(url);
        if (response.data.length > 0) {
          exhibitTemplate.value = response.data[0]
          result = true;
        }
        return result
      } catch (error) {
        console.log()
        return false;
      }
    }

    onMounted(async () => {
      await getResources();
      await getHomePageImage();
      await fetchModel();
      await fetchColor();

      const templateExists = await hasTemplate();
      const exhibitTemplateId = exhibitTemplate.value ? exhibitTemplate.value.id : null;

      if (resourceSelected.value && homePageText2.value && lastRoute && lastRoute.name === 'Admin' && templateExists && exhibitTemplateId === 6) {
        router.push('/resourceManagement');
      } else if (resourceSelected.value && homePageText2.value && lastRoute && lastRoute.name === 'Admin' && templateExists && exhibitTemplateId != 6) {
        router.push('/templateManagement');
      } /*else if (!templateExists && lastRoute && lastRoute.name === 'Admin') {
          router.push('/creation');
        }*/


    });



    return {
      welcomeText,
      embedUrl,
      selectedTemplate,
      templates,
      homePageText,
      resourceSelected,
      resources,
      iframeKey,
      loading,
      success,
      resourcesList,
      exhibitId,
      homePageText2,
      rightsRef,
      saveError,
      color,
      uploading,
      uploadProgress,
      isDragging,
      selectedFiles,
      filesToUpload,
      uploadCurrent,
      uploadTotal,
      exhibitTemplate,
      launchResourceSelected,
      onDrop,
      onFilesSelected,
      importFiles,
      getFileIcon,
      getResources,
      sendHomePageImage,
      rightsAdded,
      saveRights,
      saveModel,
      fetchModel,
      saveColor,
      fetchColor,
      column1,
      column2,
      column3,
      returnSource,
      returnIcon,
      returnImageId,
      iconCatalog,
      saveReturnButton,
      layoutEditor
    };
  },
};
</script>
  
<style scoped>
.container {
  display: flex;
  justify-content: space-between;
}

.column {
  flex: 1;
  margin: 10px;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 10px;
}

input[type="file"] {
  display: block;
  box-sizing: border-box;
  width: 100%;
  border: 1px solid #bdbdbd;
  padding: 10px 12px;
  border-radius: 4px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #575757;
  background-color: #fff;
  background-image: none;
  -webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
  transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
}

input[type="file"]:focus {
  border-color: #3f51b5;
  outline: 0;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(63, 81, 181, 0.6);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(63, 81, 181, 0.6);
}

.preview-iframe {
  border: none;
  /* Supprime les bordures par défaut */
  border-radius: 10px;
  /* Ajoute des bordures arrondies */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  /* Ajoute une légère ombre pour un effet 3D */
  overflow: auto;

}

.iframe-wrapper iframe {
  width: 1000px;
  /* Largeur originale pour le ratio 16:9 */
  height: 562.5px;
  /* Hauteur calculée pour le ratio 16:9 */
  transform: scale(0.5);
  /* Mise à l'échelle pour ajuster à 500px de largeur */
  transform-origin: top left;
  /* Aligner en haut à gauche */
  border: 0;
  /* Optionnel: enlève la bordure de l'iframe */
}

.iframe-wrapper {
  width: 500px;
  /* Largeur du conteneur */
  height: 281.25px;
  /* Hauteur du conteneur ajustée pour le contenu à l'échelle */
  overflow: hidden;
  /* Cache les débordements pour ne pas montrer de barres de défilement */
  margin-left: auto;
  margin-right: auto;
}

.banner {
    position: fixed !important;
    top: 20px !important;
    right: 20px !important;
    left: auto !important;
    transform: none !important;
    z-index: 99999;
    padding: 15px 24px;
    border-radius: 5px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    font-size: 16px;
    color: white;
    max-width: 350px;
    animation: fadeInSlide 0.4s ease-out;
}

.banner-success {
    background-color: #10b981;
}

.banner-error {
    background-color: #f44336;
}

@keyframes fadeInSlide {
    from {
        opacity: 0;
        transform: translateY(-10px) scale(0.95);
    }
    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

/* Responsive toast notifications */
@media (max-width: 768px) {
    .banner {
        top: 10px;
        right: 10px;
        left: 10px;
        max-width: none;
        padding: 14px 20px;
        font-size: 15px;
    }
}

@media (max-width: 480px) {
    .banner {
        padding: 12px 18px;
        font-size: 14px;
    }
}


.loader {
  position: fixed;
  /* ou "absolute" selon le besoin */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: rgba(255, 255, 255, 0.8);
  /* Un fond blanc semi-transparent */
}

.fixed-layout {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  /* espace entre les éléments */
}

.column-toggle-container {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.drop-zone {
  border: 2px dashed #bdbdbd;
  border-radius: 8px;
  padding: 24px;
  text-align: center;
  transition: border-color 0.2s, background-color 0.2s;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.drop-zone--active {
  border-color: #1976d2;
  background-color: rgba(25, 118, 210, 0.06);
}
h4 {
    font-size: 20px;
    font-weight: 600;
}
</style>
  